/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_EXHIBITORS (state, exhibitors) {
    state.exhibitors = exhibitors
  },
  SET_EXHIBITORTYPES (state, types){
    state.exhibitortypes = types
  },
  REMOVE_RECORD (state, itemId) {
    const exhibitorIndex = state.exhibitors.findIndex((u) => u.Email === itemId)
    state.exhibitors.splice(exhibitorIndex, 1)
  }
}
